module.exports = __webpack_public_path__ + "static/media/S (181).c4858dcd.jpg";